import type { QueryClient } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { i18n as I18nType } from "i18next";
import { type AuthClient } from "~/api/AuthClient";

interface RouterContext {
  authClient: AuthClient;
  queryClient: QueryClient;
  i18n: I18nType;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context: { authClient } }) => {
    await authClient.initialRefreshPromise;
  },
  head: () => ({
    meta: [
      // {
      //   name: "description",
      //   content: "My App is a web application",
      // },
      {
        title: "Data Insights",
      },
    ],
    links: [
      {
        rel: "icon",
        href: "/favicon.png",
      },
    ],
  }),
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <div className="isolate">
        {/*
          bricks-ui overlays (Dialog, Tooltip, Toast, etc.) portal to the end of
          document.body and set no z-index, so they stack purely by DOM order.
          `isolate` confines the main content's z-indexes to their own stacking
          context, keeping them from painting over those overlays.
          */}
        <Outlet />
      </div>
      {/* <ReactQueryDevtools buttonPosition="bottom-right" /> */}
      {/* <TanStackRouterDevtools position="bottom-right" /> */}
    </>
  );
}
